// Dados FICTÍCIOS de profissionais — apenas exemplos para teste visual (Etapa 6)
export const ETAPAS_FILTRO = ["Planejamento", "Gestação", "Parto", "Pós-parto"];

export const CATEGORIAS_FILTRO = [
  "Obstetras",
  "Pediatras",
  "Doulas",
  "Consultoras de amamentação",
  "Psicólogos perinatais",
  "Nutricionistas",
  "Fisioterapeutas pélvicos",
  "Clínicas de fertilidade",
];

export const CIDADES_FILTRO = ["São Paulo", "Campinas", "Rio de Janeiro"];
export const IDIOMAS_FILTRO = ["Português", "Inglês", "Espanhol", "Libras"];

export const CATEGORIA_COR = {
  Obstetras: "pink",
  Pediatras: "eucalipto",
  Doulas: "gold",
  "Consultoras de amamentação": "taupe",
  "Psicólogos perinatais": "pink",
  Nutricionistas: "eucalipto",
  "Fisioterapeutas pélvicos": "gold",
  "Clínicas de fertilidade": "taupe",
};

export const COR_CLASSES = {
  pink: { bg: "bg-maternnia-pink/12", text: "text-maternnia-pink" },
  eucalipto: { bg: "bg-maternnia-eucalipto/12", text: "text-maternnia-eucalipto" },
  gold: { bg: "bg-maternnia-gold/15", text: "text-maternnia-gold" },
  taupe: { bg: "bg-maternnia-taupe/12", text: "text-maternnia-taupe" },
};

export const PROFISSIONAIS_EXEMPLO = [
  {
    id: "p1", nome: "Dra. Helena Prado", categoria: "Obstetras", cidade: "São Paulo", bairro: "Jardins",
    etapas: ["Gestação", "Parto"], online: true, presencial: true, particular: true, domiciliar: false,
    idiomas: ["Português", "Inglês"], verificado: true,
    descricao: "Obstetra com foco em gestação de baixo risco e parto humanizado.",
  },
  {
    id: "p2", nome: "Mariana Lopes", categoria: "Doulas", cidade: "São Paulo", bairro: "Pinheiros",
    etapas: ["Gestação", "Parto"], online: false, presencial: true, particular: true, domiciliar: true,
    idiomas: ["Português"], verificado: true,
    descricao: "Doula de parto com apoio contínuo e preparação para o nascimento.",
  },
  {
    id: "p3", nome: "Espaço Nutrir", categoria: "Nutricionistas", cidade: "Campinas", bairro: "Cambuí",
    etapas: ["Planejamento", "Gestação", "Pós-parto"], online: true, presencial: true, particular: true, domiciliar: false,
    idiomas: ["Português", "Espanhol"], verificado: false,
    descricao: "Nutrição materno-infantil em todas as fases da jornada.",
  },
  {
    id: "p4", nome: "Dr. Rafael Antunes", categoria: "Pediatras", cidade: "São Paulo", bairro: "Moema",
    etapas: ["Pós-parto"], online: true, presencial: true, particular: true, domiciliar: true,
    idiomas: ["Português", "Inglês"], verificado: true,
    descricao: "Pediatria com acompanhamento desde o pré-natal e primeiros cuidados.",
  },
  {
    id: "p5", nome: "Camila Ferraz", categoria: "Consultoras de amamentação", cidade: "Rio de Janeiro", bairro: "Botafogo",
    etapas: ["Pós-parto"], online: true, presencial: false, particular: true, domiciliar: true,
    idiomas: ["Português"], verificado: false,
    descricao: "Consultoria de amamentação para os primeiros dias com apoio prático.",
  },
  {
    id: "p6", nome: "Instituto Equilíbrio", categoria: "Psicólogos perinatais", cidade: "São Paulo", bairro: "Vila Mariana",
    etapas: ["Planejamento", "Gestação", "Pós-parto"], online: true, presencial: true, particular: true, domiciliar: false,
    idiomas: ["Português", "Inglês"], verificado: true,
    descricao: "Saúde emocional perinatal e apoio psicológico para mães e famílias.",
  },
  {
    id: "p7", nome: "Movimento Pélvico", categoria: "Fisioterapeutas pélvicos", cidade: "Campinas", bairro: "Taquaral",
    etapas: ["Gestação", "Parto", "Pós-parto"], online: false, presencial: true, particular: true, domiciliar: false,
    idiomas: ["Português"], verificado: false,
    descricao: "Fisioterapia pélvica para gestação, preparo para o parto e recuperação.",
  },
  {
    id: "p8", nome: "Clínica Vida Fértil", categoria: "Clínicas de fertilidade", cidade: "São Paulo", bairro: "Itaim Bibi",
    etapas: ["Planejamento"], online: true, presencial: true, particular: true, domiciliar: false,
    idiomas: ["Português", "Inglês", "Espanhol"], verificado: true,
    descricao: "Reprodução assistida e investigação de fertilidade com acolhimento.",
  },
  {
    id: "p9", nome: "Dra. Beatriz Nunes", categoria: "Obstetras", cidade: "Rio de Janeiro", bairro: "Tijuca",
    etapas: ["Gestação", "Parto"], online: true, presencial: true, particular: true, domiciliar: false,
    idiomas: ["Português"], verificado: false,
    descricao: "Acompanhamento de pré-natal e plano de parto personalizado.",
  },
  {
    id: "p10", nome: "Sofia Andrade", categoria: "Doulas", cidade: "Campinas", bairro: "Centro",
    etapas: ["Parto", "Pós-parto"], online: true, presencial: true, particular: true, domiciliar: true,
    idiomas: ["Português", "Libras"], verificado: true,
    descricao: "Doula de parto e pós-parto com suporte à amamentação.",
  },
  {
    id: "p11", nome: "NutriMaterna", categoria: "Nutricionistas", cidade: "São Paulo", bairro: "Perdizes",
    etapas: ["Planejamento", "Gestação"], online: true, presencial: false, particular: true, domiciliar: false,
    idiomas: ["Português", "Inglês"], verificado: false,
    descricao: "Planejamento alimentar pré-concepcional e durante a gestação.",
  },
  {
    id: "p12", nome: "Dr. Lucas Moreira", categoria: "Pediatras", cidade: "Rio de Janeiro", bairro: "Copacabana",
    etapas: ["Pós-parto"], online: true, presencial: true, particular: true, domiciliar: false,
    idiomas: ["Português", "Espanhol"], verificado: true,
    descricao: "Pediatria neonatal e orientação para os primeiros meses.",
  },
];

export const getInitials = (nome) =>
  nome
    .replace(/^(Dra?\.?|Instituto|Clínica|Espaço)\s+/i, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

// Templates de perfil por categoria (exemplos fictícios)
const TEMPLATES = {
  Obstetras: {
    especialidades: ["Pré-natal de baixo risco", "Parto humanizado", "Gestação de alto risco"],
    servicos: ["Consulta de pré-natal", "Elaboração de plano de parto", "Acompanhamento de parto"],
    diferenciais: ["Atendimento humanizado", "Disponibilidade para dúvidas", "Equipe multidisciplinar"],
    formacao: ["Medicina — Universidade Federal", "Residência em Ginecologia e Obstetrícia"],
    credenciais: ["CRM ativo", "Título de especialista (TEGO)"],
  },
  Pediatras: {
    especialidades: ["Neonatologia", "Aleitamento materno", "Primeiros cuidados"],
    servicos: ["Consulta pré-natal pediátrica", "Acompanhamento do recém-nascido", "Orientação de sono"],
    diferenciais: ["Atendimento acolhedor", "Suporte por mensagem", "Visita ainda na maternidade"],
    formacao: ["Medicina — Universidade Estadual", "Residência em Pediatria"],
    credenciais: ["CRM ativo", "Título de especialista em Pediatria"],
  },
  Doulas: {
    especialidades: ["Apoio no trabalho de parto", "Preparação para o parto", "Pós-parto"],
    servicos: ["Encontros de preparação", "Acompanhamento no parto", "Suporte no puerpério"],
    diferenciais: ["Apoio contínuo e presente", "Plantão próximo à data", "Escuta e acolhimento"],
    formacao: ["Formação em Doulagem", "Cursos de educação perinatal"],
    credenciais: ["Certificação reconhecida", "Formação continuada"],
  },
  "Consultoras de amamentação": {
    especialidades: ["Pega e posicionamento", "Baixa produção", "Desmame respeitoso"],
    servicos: ["Consultoria presencial", "Atendimento domiciliar", "Acompanhamento online"],
    diferenciais: ["Suporte prático", "Materiais de apoio", "Retornos incluídos"],
    formacao: ["Enfermagem / Saúde", "Formação em consultoria de amamentação"],
    credenciais: ["Certificação em amamentação", "Formação continuada"],
  },
  "Psicólogos perinatais": {
    especialidades: ["Saúde emocional na gestação", "Depressão pós-parto", "Transição para a maternidade"],
    servicos: ["Sessões individuais", "Atendimento online", "Grupos de apoio"],
    diferenciais: ["Abordagem acolhedora", "Sigilo e segurança", "Foco perinatal"],
    formacao: ["Psicologia — Universidade", "Especialização em Psicologia Perinatal"],
    credenciais: ["CRP ativo", "Especialização reconhecida"],
  },
  Nutricionistas: {
    especialidades: ["Nutrição pré-concepcional", "Nutrição na gestação", "Alimentação no pós-parto"],
    servicos: ["Avaliação nutricional", "Plano alimentar personalizado", "Acompanhamento contínuo"],
    diferenciais: ["Plano individualizado", "Sem dietas restritivas", "Suporte por mensagem"],
    formacao: ["Nutrição — Universidade", "Especialização materno-infantil"],
    credenciais: ["CRN ativo", "Especialização reconhecida"],
  },
  "Fisioterapeutas pélvicos": {
    especialidades: ["Preparação para o parto", "Reabilitação pós-parto", "Saúde do assoalho pélvico"],
    servicos: ["Avaliação pélvica", "Sessões de fisioterapia", "Orientação de exercícios"],
    diferenciais: ["Atendimento individual", "Acompanhamento de evolução", "Ambiente acolhedor"],
    formacao: ["Fisioterapia — Universidade", "Especialização em saúde pélvica"],
    credenciais: ["CREFITO ativo", "Especialização reconhecida"],
  },
  "Clínicas de fertilidade": {
    especialidades: ["Investigação de fertilidade", "Fertilização in vitro", "Inseminação"],
    servicos: ["Consulta de fertilidade", "Exames e investigação", "Tratamentos de reprodução assistida"],
    diferenciais: ["Equipe multidisciplinar", "Acompanhamento humanizado", "Estrutura completa"],
    formacao: ["Equipe médica especializada", "Centro de reprodução assistida"],
    credenciais: ["Registro ANVISA", "Equipe com CRM ativo"],
  },
};

const slugify = (s) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "");

export const buildPerfil = (base) => {
  const tpl = TEMPLATES[base.categoria] || TEMPLATES.Obstetras;
  const handle = slugify(base.nome);
  return {
    ...base,
    ...tpl,
    contato: {
      telefone: "(11) 9 0000-0000",
      email: `contato@${handle}.com.br`,
      site: `www.${handle}.com.br`,
      instagram: `@${handle}`,
    },
    conteudos: [
      { title: `Dicas de ${base.categoria.toLowerCase()} para a sua etapa`, min: "5 min" },
      { title: "Perguntas frequentes respondidas", min: "4 min" },
    ],
  };
};

